import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const serviceName = 'documents';
export const documentServiceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const DocumentServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: documentServiceEventType(),
}));
